import { Grid, TextField } from "@material-ui/core";
import { useModalStyles } from "@saleor/autobooking/styles/modalStyles";
import AutoBookingConfig from "@saleor/autobooking/utils/objects";
import SingleSelectField from "@saleor/components/SingleSelectField";
import { AutoBookingErrorFragment } from "@saleor/fragments/types/AutoBookingErrorFragment";
import {
  AutobookingConfigUpdateInput,
  CourierFilter
} from "@saleor/types/globalTypes";
import { getFormErrors } from "@saleor/utils/errors";
import React from "react";

export interface StatusMinutesFieldProps {
  courierChoices: Array<{
    label: string;
    value: CourierFilter;
  }>;
  autoBookingConfig: AutoBookingConfig;
  setConfig: React.Dispatch<React.SetStateAction<AutoBookingConfig>>;
  disabledField: boolean;
  errors: AutoBookingErrorFragment[];
  resetFormErrors: (field?: string) => void;
}

const StatusMinutesField: React.FC<StatusMinutesFieldProps> = props => {
  const {
    courierChoices,
    autoBookingConfig,
    setConfig,
    disabledField,
    errors,
    resetFormErrors
  } = props;

  const classes = useModalStyles(props);

  const formFields: Array<keyof AutobookingConfigUpdateInput> = [
    "readyStatusMinutes",
    "collectedStatusMinutes",
    "anyStatusMinutes",
    "courier"
  ];
  const formErrors = getFormErrors<
    keyof AutobookingConfigUpdateInput,
    AutoBookingErrorFragment
  >(formFields, errors);

  return (
    <div className={classes.modalFormFields}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <SingleSelectField
            onChange={e => {
              if (e.target.value === "") {
                setConfig({
                  ...autoBookingConfig,
                  courier: null
                });
              } else {
                setConfig({
                  ...autoBookingConfig,
                  courier: e.target.value
                });
              }
              resetFormErrors("courier");
            }}
            label="Assigned Courier"
            placeholder="Select a Courier *"
            choices={courierChoices}
            name="assignedCourier"
            value={autoBookingConfig?.courier || ""}
            disabled={disabledField}
            error={!disabledField && !!formErrors.courier}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <hr />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <TextField
            id="readyStatusMinutesTxt"
            required
            fullWidth
            type="number"
            label={"Ready Status (mins)"}
            value={autoBookingConfig?.readyStatusMinutes || ""}
            onChange={e => {
              if (e.target.value === "") {
                setConfig({
                  ...autoBookingConfig,
                  readyStatusMinutes: null
                });
              } else {
                setConfig({
                  ...autoBookingConfig,
                  readyStatusMinutes: Number(e.target.value)
                });
              }
            }}
            disabled={disabledField}
            error={!disabledField && !!formErrors.readyStatusMinutes}
            onFocus={() => resetFormErrors()}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <TextField
            id="collectedStatusMinutesTxt"
            required
            fullWidth
            type="number"
            label={"Collected Status (mins)"}
            value={autoBookingConfig?.collectedStatusMinutes || ""}
            onChange={e => {
              if (e.target.value === "") {
                setConfig({
                  ...autoBookingConfig,
                  collectedStatusMinutes: null
                });
              } else {
                setConfig({
                  ...autoBookingConfig,
                  collectedStatusMinutes: Number(e.target.value)
                });
              }
            }}
            disabled={disabledField}
            error={!disabledField && !!formErrors.collectedStatusMinutes}
            onFocus={() => resetFormErrors()}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <TextField
            id="anyStatusMinutesTxt"
            required
            fullWidth
            type="number"
            label={"Any Status (mins)"}
            value={autoBookingConfig?.anyStatusMinutes || ""}
            onChange={e => {
              if (e.target.value === "") {
                setConfig({
                  ...autoBookingConfig,
                  anyStatusMinutes: null
                });
              } else {
                setConfig({
                  ...autoBookingConfig,
                  anyStatusMinutes: Number(e.target.value)
                });
              }
            }}
            disabled={disabledField}
            error={!disabledField && !!formErrors.anyStatusMinutes}
            onFocus={() => resetFormErrors()}
          />
        </Grid>
      </Grid>
    </div>
  );
};

StatusMinutesField.displayName = "StatusMinutesField";
export default StatusMinutesField;
